<template>
  <BlockListLeaderboard
    :users="topUsers"
    v-bind="leaderboardContent"
    @on-filter="onSetFilter"
  />
</template>

<script setup>
defineProps({
    leaderboardContent: {
        type: Object,
        required: true,
    },
});

const range = ref('daily');

const {
    data: topUsers,
    error,
} = useLazyFetch(
    '/api/codes/leaderboard',
    {
        server: false,
        method: 'POST',
        body: {
            range,
        },
    },
);

watch(() => error.value, (e) => {
    if (e) {
        useSentryError(e, {
            useThrow: false,
            payload: { range: range.value },
            response: topUsers.value,
        });
    }
});

const onSetFilter = (event) => {
    range.value = event;
};
</script>
